import type { ReactNode } from 'react';
import { Box } from '@ksyos/design-system';

export type ProcessStartWizardCardProps = {
    children: ReactNode;
};

export function ProcessStartWizardCard({ children }: ProcessStartWizardCardProps) {
    return (
        <Box
            backgroundColor="white"
            borderRadius="base"
            boxShadow="base"
        >
            {children}
        </Box>
    );
}
